import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import MTextField from "@mui/material/TextField";
import get from "lodash/get";
import { useFormContext, Controller } from "react-hook-form";

const CssTextField = styled(MTextField)({
	"& input": {
		borderWidth: 0,
		padding: "10px 12px",
	},
	"& input:focus": {
		outline: 0,
		boxShadow: "none",
	},
});

const TextField = ({ name, label, onChange, ...props }) => {
	const { control, formState } = useFormContext();
	const { errors } = formState;
	const error = get(errors, name);

	const handleChange = (e) => {
		if (onChange) {
			const { value } = e.target;
			onChange(value);
		}
	};

	return (
		<>
			<Controller
				name={name}
				control={control}
				render={({ field }) => (
					<CssTextField
						{...field}
						{...props}
						label={label}
						variant="outlined"
						error={!!error}
						helperText={error?.message}
						onChange={(e) => {
							handleChange(e);
							field.onChange(e);
						}}
					/>
				)}
			/>
		</>
	);
};

TextField.propTypes = {
	label: PropTypes.string.isRequired,
	autoFocus: PropTypes.bool,
	fullWidth: PropTypes.bool,
	variant: PropTypes.string,
	required: PropTypes.bool,
};
export default TextField;
